/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business Mall Scorerフロントエンドのエントリーポイント。Faro初期化後にReact StrictMode + Appをrootにマウント
 * @graph-connects none
 */
// Faro初期化は他のimportより前に実行
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'mall' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import './i18n';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
